import styles from './news.module.css'
import globalStyles from '../search.module.css';
import LazyImage from "components/LazyImage";

type Props = {
    locationName: string, 
    newsArticles: [], 
    searchCriteria: string
}

type article = {
    _source: {
        post_title: string,
        permalink: string,
        post_date: string,
        post_content: string,
        post_id: number,
        featured_image: {
            value: {
                sizes: {
                    medium: string
                }
            }
        }
    }
}

const News = ({ locationName, newsArticles, searchCriteria }: Props) => {
    const extractCreator = (text) => {
        const filteredText = text.replace(/(<([^>]+)>)/gi, "");
        const textArea = filteredText.match(/[^\.!\?]+[\.!\?]+/g);
        let finalText = "";


        for (text in textArea) {
            if (finalText.length < 400) {
                finalText = finalText + textArea[text]
            } else {
                break
            }
        }
        return finalText
    }

    return (
        <div className={styles.newsContainer}>
            <h2>Latest retail news {searchCriteria === 'NEAR ME' ? '' : 'in'} {locationName}</h2>
            <div className={styles.newsContainerInner}>
                {newsArticles.map((article: article) => {
                    const source = article._source;
                    const image = {
                        origin: "internal",
                        src: source.featured_image.value.sizes.medium,
                        alt: source.post_title,
                        layout: "fill",
                        objectFit: "cover"
                    }
                    return (
                        <a href={source.permalink} key={source.post_id}>
                            <div className={styles.articleContainer}>
                                <div className={styles.imgContainer}> <LazyImage {...image} /> </div>
                                <div className={styles.articleContent}>
                                    <h3 dangerouslySetInnerHTML={{ __html: source.post_title }} />
                                    <p className={styles.date}>{new Date(source.post_date).toDateString()}</p>
                                    <p className={styles.extract} dangerouslySetInnerHTML={{ __html: extractCreator(source.post_content) }} />
                                </div>
                                <div className={styles.link}>
                                    Read more
                                </div>
                            </div>
                        </a>
                    )
                })}
            </div>
            <div className={`${styles.buttonContainer}`}>
                <a href="https://news.completelyretail.co.uk/" target="_blank" className={globalStyles.primaryButton}>View All News</a>
            </div>
        </div>
    )

}

export default News;